const CAR_BRANDS = [
  "Audi","BMW","Mercedes-Benz","Volkswagen","Toyota","Honda","Nissan","Hyundai","Kia",
  "Mazda","Renault","Skoda","Peugeot","Ford","Opel","Volvo","Lexus","Subaru",
  "Mitsubishi","Fiat","Citroën","Seat","Chevrolet","Porsche","Tesla","Infiniti","Jeep"
];

const CAR_MODELS = {
  Audi: ["A3","A4","A5","A6","A7","A8","Q3","Q5","Q7","Q8","TT","Інше / Ввести вручну"],
  BMW: ["1 Series","3 Series","5 Series","7 Series","X1","X3","X5","X6","X7","Інше / Ввести вручну"],
  "Mercedes-Benz": ["A-Class","C-Class","E-Class","S-Class","GLA","GLC","GLE","GLS","Vito","Інше / Ввести вручну"],
  Volkswagen: ["Golf","Passat","Tiguan","Touareg","Polo","Jetta","Transporter","Multivan","Інше / Ввести вручну"],
  Toyota: ["Corolla","Camry","RAV4","Land Cruiser","Prius","Yaris","Hilux","CH-R","Інше / Ввести вручну"],
  Honda: ["Civic","Accord","CR-V","HR-V","Jazz","Pilot","Інше / Ввести вручну"],
  Nissan: ["Qashqai","X-Trail","Juke","Leaf","Micra","Navara","Інше / Ввести вручну"],
  Hyundai: ["i30","Elantra","Sonata","Tucson","Santa Fe","Kona","Accent","Інше / Ввести вручну"],
  Kia: ["Rio","Ceed","Sportage","Sorento","Optima","Stonic","Інше / Ввести вручну"],
  Mazda: ["3","6","CX-3","CX-5","CX-7","CX-9","MX-5","Інше / Ввести вручну"],
  Renault: ["Megane","Clio","Scenic","Kadjar","Koleos","Logan","Duster","Trafic","Інше / Ввести вручну"],
  Skoda: ["Octavia","Superb","Rapid","Fabia","Karoq","Kodiaq","Scala","Інше / Ввести вручну"],
  Peugeot: ["208","301","308","3008","5008","Partner","Boxer","Інше / Ввести вручну"],
  Ford: ["Fiesta","Focus","Mondeo","Kuga","Edge","Transit","Ranger","Інше / Ввести вручну"],
  Opel: ["Corsa","Astra","Insignia","Mokka","Zafira","Vivaro","Інше / Ввести вручну"],
  Volvo: ["S60","S90","V60","V90","XC40","XC60","XC90","Інше / Ввести вручну"],
  Lexus: ["IS","ES","GS","RX","NX","UX","LX","Інше / Ввести вручну"],
  Subaru: ["Impreza","Legacy","Outback","Forester","XV","WRX","Інше / Ввести вручну"],
  Mitsubishi: ["Lancer","ASX","Outlander","Pajero","Eclipse Cross","Інше / Ввести вручну"],
  Fiat: ["500","Panda","Tipo","Doblo","Fiorino","Інше / Ввести вручну"],
  Citroën: ["C3","C4","C5","Berlingo","Jumpy","Інше / Ввести вручну"],
  Seat: ["Ibiza","Leon","Ateca","Arona","Alhambra","Інше / Ввести вручну"],
  Chevrolet: ["Aveo","Cruze","Captiva","Orlando","Tahoe","Інше / Ввести вручну"],
  Porsche: ["Cayenne","Macan","Panamera","911","Taycan","Інше / Ввести вручну"],
  Tesla: ["Model 3","Model S","Model X","Model Y","Інше / Ввести вручну"],
  Infiniti: ["Q50","QX50","QX60","QX70","Інше / Ввести вручну"],
  Jeep: ["Renegade","Compass","Cherokee","Grand Cherokee","Wrangler","Інше / Ввести вручну"],
};

// ВАНТАЖНІ
const TRUCK_BRANDS = [
  "DAF","MAN","Mercedes-Benz","Volvo","Scania","Iveco","Renault Trucks","KamAZ","MAZ"
];

const TRUCK_MODELS = {
  DAF: ["XF","CF","LF","Інше / Ввести вручну"],
  MAN: ["TGL","TGM","TGS","TGX","Інше / Ввести вручну"],
  "Mercedes-Benz": ["Actros","Atego","Axor","Sprinter Van","Інше / Ввести вручну"],
  Volvo: ["FH","FM","FL","FE","Інше / Ввести вручну"],
  Scania: ["R-series","S-series","G-series","P-series","Інше / Ввести вручну"],
  Iveco: ["Stralis","Eurocargo","Daily Van","Інше / Ввести вручну"],
  "Renault Trucks": ["T","C","D","Master Van","Інше / Ввести вручну"],
  KamAZ: ["43118","65115","6520","Інше / Ввести вручну"],
  MAZ: ["5440","6430","5340","Інше / Ввести вручну"],
};

// МОТО
const MOTO_BRANDS = [
  "Yamaha","Honda","Kawasaki","Suzuki","BMW","Ducati","Harley-Davidson","KTM","Triumph","Piaggio"
];

const MOTO_MODELS = {
  Yamaha: ["MT-07","MT-09","R1","R6","Tracer 700","XMAX 300","Інше / Ввести вручну"],
  Honda: ["CB500F","CBR600RR","Africa Twin","NC750X","PCX 125","Інше / Ввести вручну"],
  Kawasaki: ["Ninja 400","Ninja 650","Z650","Z900","Versys 650","Інше / Ввести вручну"],
  Suzuki: ["GSX-R600","V-Strom 650","SV650","Burgman 400","Інше / Ввести вручну"],
  BMW: ["R1250GS","F850GS","S1000RR","G310R","Інше / Ввести вручну"],
  Ducati: ["Monster","Panigale V2","Multistrada","Scrambler","Інше / Ввести вручну"],
  "Harley-Davidson": ["Sportster","Street 750","Softail","Touring","Інше / Ввести вручну"],
  KTM: ["Duke 390","Duke 790","RC 390","Adventure 790","Інше / Ввести вручну"],
  Triumph: ["Street Triple","Tiger 800","Bonneville T120","Інше / Ввести вручну"],
  Piaggio: ["Liberty 125","MP3 300","Beverly 300","Інше / Ввести вручну"],
};

// Допоміжні отримувачі списків
const getBrandOptions = (vehicleType) => {
  if (vehicleType === "Легкове") return CAR_BRANDS;
  if (vehicleType === "Вантажне") return TRUCK_BRANDS;
  if (vehicleType === "Мото") return MOTO_BRANDS;
  return [];
};

const getModelOptions = (vehicleType, brand) => {
  if (!brand) return [];
  if (vehicleType === "Легкове") return CAR_MODELS[brand] || ["Інше / Ввести вручну"];
  if (vehicleType === "Вантажне") return TRUCK_MODELS[brand] || ["Інше / Ввести вручну"];
  if (vehicleType === "Мото") return MOTO_MODELS[brand] || ["Інше / Ввести вручну"];
  return [];
};

export const transportFields = (attrs) => {
  const a = attrs || {};
  const vt = a.vehicleType || "";

  const typeOnly = [
    {
      name: "vehicleType",
      label: "Тип ТЗ",
      type: "select",
      options: [
        "Легкове",
        "Вантажне",
        "Мото",
        "Спецтехніка",
        "Причіп",
        "Велосипед",
        "Водний транспорт",
      ],
      required: true,
    },
  ];
  if (!vt) return typeOnly;

  const base = [
    ...typeOnly,
    { name: "condition", label: "Стан", type: "select", options: ["Новий", "Б/в", "Після ДТП", "Потребує ремонту"] },
  ];

  const isMotorized = ["Легкове","Вантажне","Мото"].includes(vt);

  const carBody = [
    {
      name: "bodyType",
      label: "Кузов",
      type: "select",
      options: ["Седан","Хетчбек","Універсал","Купе","Кросовер","Позашляховик","Мінівен","Пікап","Кабріолет","Ліфтбек"],
      showIf: (st) => st.vehicleType === "Легкове",
    },
  ];

  const brandModel = [
    {
      name: "brand",
      label: "Марка",
      type: "select",
      options: getBrandOptions(vt),
      allowCustom: true,
      placeholder: "Оберіть марку або введіть свою",
      showIf: (st) => isMotorized || st.vehicleType === "Водний транспорт",
    },
    {
      name: "brandCustom",
      label: "Власна марка",
      type: "text",
      showIf: (st) => (isMotorized || st.vehicleType === "Водний транспорт") && st.brand === "Інше / Ввести вручну",
    },
    {
      name: "model",
      label: "Модель",
      type: "select",

      options: getModelOptions(vt, a.brand),
      allowCustom: true,
      placeholder: "Оберіть модель або введіть свою",
      showIf: (st) =>
        (isMotorized && (st.brand || st.brand === "Інше / Ввести вручну")) ||
        (st.vehicleType === "Водний транспорт" && st.engineType && st.engineType !== "Без двигуна"),
    },
    {
      name: "modelCustom",
      label: "Власна модель",
      type: "text",
      showIf: (st) =>
        ((isMotorized && st.model === "Інше / Ввести вручну") ||
          (st.vehicleType === "Водний транспорт" && st.model === "Інше / Ввести вручну")),
    },
  ];

  const fuelAndDrivetrain = [
    {
      name: "fuelType",
      label: "Тип пального",
      type: "select",
      options: ["Бензин","Дизель","Газ/Бензин","Електро","Гібрид"],
      showIf: (st) => ["Легкове","Вантажне","Мото"].includes(st.vehicleType),
    },
    {
      name: "transmission",
      label: "Коробка передач",
      type: "select",
      options: ["Механіка","Автомат","Робот","Варіатор"],
      showIf: (st) => ["Легкове","Вантажне"].includes(st.vehicleType),
    },
    {
      name: "driveType",
      label: "Привід",
      type: "select",
      options: ["Передній","Задній","Повний"],
      showIf: (st) => ["Легкове","Вантажне"].includes(st.vehicleType),
    },
  ];

  const yearMileageId = [
    { name: "year", label: "Рік випуску", type: "number", showIf: (st) => isMotorized || st.vehicleType === "Водний транспорт" },
    { name: "mileage", label: "Пробіг (тис. км)", type: "number", showIf: (st) => ["Легкове","Вантажне","Мото"].includes(st.vehicleType) },
    { name: "vin", label: "VIN / Серійний №", type: "text", showIf: (st) => isMotorized },
    { name: "plate", label: "Держномер", type: "text", showIf: (st) => isMotorized },
  ];

  const colorOwnersSeats = [
    { name: "color", label: "Колір", type: "text", showIf: (st) => isMotorized || st.vehicleType === "Водний транспорт" },
    { name: "owners", label: "Кількість власників", type: "number", showIf: (st) => isMotorized },
    { name: "doors", label: "Кількість дверей", type: "number", showIf: (st) => st.vehicleType === "Легкове" },
    { name: "seats", label: "Кількість місць", type: "number", showIf: (st) => ["Легкове","Вантажне"].includes(st.vehicleType) },
  ];

  const evHybrid = [
    {
      name: "batteryCapacity",
      label: "Батарея (кВт⋅год)",
      type: "number",
      step: "0.1",
      showIf: (st) => isMotorized && (st.fuelType === "Електро" || st.fuelType === "Гібрид"),
    },
    {
      name: "range",
      label: "Запас ходу (км)",
      type: "number",
      showIf: (st) => isMotorized && (st.fuelType === "Електро" || st.fuelType === "Гібрид"),
    },
  ];

  const motoExtras = [
    {
      name: "motoType",
      label: "Тип мото",
      type: "select",
      options: ["Класик","Спорт","Турер","Крос","Ендуро","Круїзер","Скутер"],
      showIf: (st) => st.vehicleType === "Мото",
    },
    {
      name: "engineVolumeCc",
      label: "Об’єм (см³)",
      type: "number",
      showIf: (st) => st.vehicleType === "Мото" && st.fuelType !== "Електро",
    },
  ];

  const truckExtras = [
    {
      name: "truckType",
      label: "Тип вантажного",
      type: "select",
      options: ["Бортовий","Фургон","Тягач","Самоскид","Рефрижератор","Цистерна","Платформа","Контейнеровоз"],
      showIf: (st) => st.vehicleType === "Вантажне",
    },
    { name: "payload", label: "Вантажопідйомність (т)", type: "number", step: "0.1", showIf: (st) => st.vehicleType === "Вантажне" },
    { name: "grossWeight", label: "Повна маса (т)", type: "number", step: "0.1", showIf: (st) => st.vehicleType === "Вантажне" },
    { name: "axles", label: "Кількість осей", type: "number", showIf: (st) => st.vehicleType === "Вантажне" },
  ];

  const water = [
    {
      name: "waterType",
      label: "Тип",
      type: "select",
      options: ["Човен","Катер","Яхта","Гідроцикл","Інше"],
      showIf: (st) => st.vehicleType === "Водний транспорт",
    },
    { name: "length", label: "Довжина (м)", type: "number", step: "0.1", showIf: (st) => st.vehicleType === "Водний транспорт" },
    {
      name: "hull",
      label: "Матеріал корпусу",
      type: "select",
      options: ["Пластик","Алюміній","Дерево","GFK","Інше"],
      showIf: (st) => st.vehicleType === "Водний транспорт",
    },
    {
      name: "engineType",
      label: "Двигун",
      type: "select",
      options: ["Підвісний","Внутрішній","Електро","Без двигуна"],
      showIf: (st) => st.vehicleType === "Водний транспорт",
    },
    {
      name: "engineHp",
      label: "Потужність двигуна (к.с.)",
      type: "number",
      showIf: (st) => st.vehicleType === "Водний транспорт" && st.engineType && st.engineType !== "Без двигуна",
    },
    {
      name: "fuelTypeWater",
      label: "Пальне",
      type: "select",
      options: ["Бензин","Дизель","Електро"],
      showIf: (st) => st.vehicleType === "Водний транспорт" && st.engineType && st.engineType !== "Без двигуна",
    },
  ];

  const bicycle = [
    {
      name: "bikeType",
      label: "Тип велосипеда",
      type: "select",
      options: ["MTB","Шосе","Гравійний","Міський","BMX","Тріал","Електровелосипед"],
      showIf: (st) => st.vehicleType === "Велосипед",
    },
    { name: "frameSize", label: "Розмір рами", type: "text", showIf: (st) => st.vehicleType === "Велосипед" },
    {
      name: "wheelSize",
      label: "Діаметр коліс",
      type: "select",
      options: ['16"','20"','24"','26"','27.5"','28"','29"'],
      showIf: (st) => st.vehicleType === "Велосипед",
    },
    {
      name: "batteryCapacity",
      label: "Батарея (Вт⋅год)",
      type: "number",
      step: "1",
      showIf: (st) => st.vehicleType === "Велосипед" && st.bikeType === "Електровелосипед",
    },
    {
      name: "range",
      label: "Запас ходу (км)",
      type: "number",
      showIf: (st) => st.vehicleType === "Велосипед" && st.bikeType === "Електровелосипед",
    },
    { name: "color", label: "Колір", type: "text", showIf: (st) => st.vehicleType === "Велосипед" },
  ];

  const trailer = [
    {
      name: "trailerType",
      label: "Тип причепа",
      type: "select",
      options: ["Легковий","Вантажний","Напівпричіп","Причіп-дача","Автовоз","Рефрижераторний","Цистерна","Бортовий","Тентований","Контейнеровоз"],
      showIf: (st) => st.vehicleType === "Причіп",
    },
    { name: "payload", label: "Вантажопідйомність (т)", type: "number", step: "0.1", showIf: (st) => st.vehicleType === "Причіп" },
    { name: "axles", label: "Кількість осей", type: "number", showIf: (st) => st.vehicleType === "Причіп" },
    {
      name: "brakes",
      label: "Гальма",
      type: "select",
      options: ["Без гальм","Інерційні","Пневматичні"],
      showIf: (st) => st.vehicleType === "Причіп",
    },
    { name: "dimensions", label: "Габарити платформи (Д×Ш×В, м)", type: "text", showIf: (st) => st.vehicleType === "Причіп" },
  ];

  const special = [
    {
      name: "specialType",
      label: "Тип спецтехніки",
      type: "select",
      options: ["Екскаватор","Навантачувач","Бульдозер","Кран","Трактор","Каток","Автовишка","Комбайн","Інше"],
      showIf: (st) => st.vehicleType === "Спецтехніка",
    },
    { name: "specialHasEngine", label: "Двигун", type: "select", options: ["Так","Ні"], showIf: (st) => st.vehicleType === "Спецтехніка" },
    { name: "year", label: "Рік випуску", type: "number", showIf: (st) => st.vehicleType === "Спецтехніка" && st.specialHasEngine === "Так" },
    { name: "fuelType", label: "Тип пального", type: "select", options: ["Дизель","Бензин","Електро"], showIf: (st) => st.vehicleType === "Спецтехніка" && st.specialHasEngine === "Так" },
    { name: "power", label: "Потужність (к.с.)", type: "number", showIf: (st) => st.vehicleType === "Спецтехніка" && st.specialHasEngine === "Так" },
    { name: "operatingHours", label: "Напрацювання (м/год)", type: "number", showIf: (st) => st.vehicleType === "Спецтехніка" && st.specialHasEngine === "Так" },
    { name: "weight", label: "Маса (т)", type: "number", step: "0.1", showIf: (st) => st.vehicleType === "Спецтехніка" && st.specialHasEngine === "Ні" },
    { name: "color", label: "Колір", type: "text", showIf: (st) => st.vehicleType === "Спецтехніка" },
  ];

  if (vt === "Легкове") {
  return [
    ...typeOnly,                                 // Тип ТЗ
    ...brandModel,                               // Марка, Модель
    ...carBody,                                  // Кузов
    ...fuelAndDrivetrain.filter(f => f.name === "fuelType"), // Тип палива
    { name: "engineVolume", label: "Об’єм двигуна (л)", type: "number", step: "0.1" }, // об'єм
    ...fuelAndDrivetrain.filter(f => f.name !== "fuelType"), // Коробка, Привід
    ...yearMileageId.filter(f => f.name === "year"),         // Рік випуску
    ...yearMileageId.filter(f => f.name === "mileage"),      // Пробіг
    ...base.filter(f => f.name === "condition"),             // Стан
    ...colorOwnersSeats.filter(f => f.name === "color"),     // Колір
    ...yearMileageId.filter(f => f.name === "vin"),          // VIN
    ...yearMileageId.filter(f => f.name === "plate"),        // Держномер
    ...colorOwnersSeats.filter(f => f.name === "owners"),    // Кількість власників
    ...colorOwnersSeats.filter(f => f.name === "doors"),     // Дверей
    ...colorOwnersSeats.filter(f => f.name === "seats"),     // Місць
    ...evHybrid,                                             // EV параметри
  ];
}
  if (vt === "Вантажне") {
  return [
    ...typeOnly,
    ...brandModel,
    ...fuelAndDrivetrain.filter(f => f.name === "fuelType"),
    { name: "engineVolume", label: "Об’єм двигуна (л)", type: "number", step: "0.1" },
    ...fuelAndDrivetrain.filter(f => f.name !== "fuelType"),
    ...yearMileageId.filter(f => f.name === "year"),
    ...yearMileageId.filter(f => f.name === "mileage"),
    ...base.filter(f => f.name === "condition"),
    ...colorOwnersSeats.filter(f => f.name === "color"),
    ...yearMileageId.filter(f => f.name === "vin"),
    ...yearMileageId.filter(f => f.name === "plate"),
    ...colorOwnersSeats.filter(f => f.name === "owners"),
    ...colorOwnersSeats.filter(f => f.name === "seats"),
    ...truckExtras,
    ...evHybrid,
  ];
}

if (vt === "Мото") {
  return [
    ...typeOnly,
    ...brandModel,
    ...fuelAndDrivetrain.filter(f => f.name === "fuelType"),
    { name: "engineVolumeCc", label: "Об’єм двигуна (см³)", type: "number" },
    ...fuelAndDrivetrain.filter(f => f.name !== "fuelType"),
    ...yearMileageId.filter(f => f.name === "year"),
    ...yearMileageId.filter(f => f.name === "mileage"),
    ...base.filter(f => f.name === "condition"),
    ...colorOwnersSeats.filter(f => f.name === "color"),
    ...yearMileageId.filter(f => f.name === "vin"),
    ...yearMileageId.filter(f => f.name === "plate"),
    ...colorOwnersSeats.filter(f => f.name === "owners"),
    ...colorOwnersSeats.filter(f => f.name === "seats"),
    ...motoExtras,
    ...evHybrid,
  ];
}
  if (vt === "Водний транспорт") {
    return [
      ...base,
      ...water,
      // бренд/модель/рік – з'являться автоматично при двигуні,
      ...brandModel,
      ...yearMileageId.filter(f => f.name !== "mileage" && f.name !== "vin" && f.name !== "plate"),
      ...colorOwnersSeats.filter(f => f.name === "color"),
    ];
  }
  if (vt === "Велосипед") {
    return [
      ...base,
      ...bicycle,
    ];
  }
  if (vt === "Причіп") {
    return [
      ...base,
      ...trailer,
    ];
  }
  if (vt === "Спецтехніка") {
    return [
      ...base,
      ...special,
    ];
  }

  return base;
};
